<template>
  <div>
      activities
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>